//Get Weather Constants
const key = process.env.REACT_APP_WEATHER_API_KEY;
const host = process.env.REACT_APP_WEATHER_API_HOST;

if (key === undefined) {
  throw new Error(
    "No Open Weather API Key defined - ensure you set a variable called WEATHER_API_KEY"
  );
}

if (host === undefined) {
  throw new Error(
    "No Open Weather API Key defined - ensure you set a variable called WEATHER_API_HOST"
  );
}

export const options = {
  method: "GET",
  headers: {
    "X-RapidAPI-Key": key,
    "X-RapidAPI-Host": host,
  },
};

export const getWeather = async (location, setCurrentWeather) => {
  try {
    const geo = await fetch(
      `https://geocoding-api.open-meteo.com/v1/search?name=${encodeURIComponent(
        location
      )}&count=1`
    );

    const geoData = await geo.json();

    const { latitude, longitude, country } = geoData.results[0];

    const weatherCodes = {
      0: "Clear sky",
      1: "Mainly clear",
      2: "Partly cloudy",
      3: "Overcast",
      45: "Fog",
      48: "Depositing rime fog",
      51: "Light drizzle",
      53: "Moderate drizzle",
      55: "Dense drizzle",
      56: "Light freezing drizzle",
      57: "Dense freezing drizzle",
      61: "Slight rain",
      63: "Moderate rain",
      65: "Heavy rain",
      66: "Light freezing rain",
      67: "Heavy freezing rain",
      71: "Slight snow",
      73: "Moderate snow",
      75: "Heavy snow",
      77: "Snow grains",
      80: "Slight rain showers",
      81: "Moderate rain showers",
      82: "Violent rain showers",
      85: "Slight snow showers",
      86: "Heavy snow showers",
      95: "Thunderstorm",
      96: "Thunderstorm with slight hail",
      99: "Thunderstorm with heavy hail",
    };

    const weather = await fetch(
      `https://api.open-meteo.com/v1/forecast?latitude=${latitude}&longitude=${longitude}&current=temperature_2m,apparent_temperature,relative_humidity_2m,precipitation,cloud_cover,wind_speed_10m,weather_code,is_day&timezone=auto`
    );

    const weatherData = await weather.json();
    weatherData.current.condition =
      weatherCodes[weatherData.current.weather_code] ?? "Unknown";

    weatherData.location = location;
    weatherData.name = location;
    weatherData.country = country;
    weatherData.current.temp_f = Math.round(
      (weatherData.current.temperature_2m * 9) / 5 + 32
    );
    weatherData.current.feelslike_f = Math.round(
      (weatherData.current.apparent_temperature * 9) / 5 + 32
    );

    weatherData.current.precip_in = Math.round(
      weatherData.current.precipitation / 25.4
    );
    weatherData.current.wind_mph = Math.round(
      weatherData.current.wind_speed_10m * 0.621371
    );

    delete weatherData.current.weather_code;

    if (!weatherData) {
      return console.log("Hi from helper function - please pick a valid city");
    }

    setCurrentWeather(weatherData);
  } catch (err) {
    console.log("line 47 error from helpers.js");
    console.log(err.message);
  }
};

const imageObject = {
  cold: "./images/cold.png",
  frigid: "./images/frigid.png",
  happySun: "./images/happySun.png",
  hot: "./images/hot.png",
  ski: "./images/ski.png",
  sleepy: "./images/sleepy.png",
  warm: "./images/warm.png",
  weird: "./images/weird.png",
  rain: "./images/rain.png",
  questionable: "./images/questionable.png",
  fine: "./images/fine.png",
};

//Set image, message and animation
export const findImage = (props, setImage, setMessage, setAnimation) => {
  const rainString = "rain";
  const cloudString = "cloud";
  const sunString = "sun";
  const snowString = "snow";

  if (
    props.currentWeather.current !== undefined &&
    props.currentWeather.current.is_day === 0
  ) {
    setImage(imageObject.sleepy);
    setMessage("...but it's night - why do you even want to know??");
    setAnimation("disappear");
  } else if (
    props.currentWeather.current.condition.toLowerCase().includes("thunder") ||
    props.currentWeather.current.condition.toLowerCase().includes("blizzard") ||
    props.currentWeather.current.condition.toLowerCase().includes("heavy") ||
    props.currentWeather.current.condition.toLowerCase().includes("sleet") ||
    props.currentWeather.current.condition.toLowerCase().includes("ice") ||
    props.currentWeather.current.condition.toLowerCase().includes("torrential")
  ) {
    setImage(imageObject.weird);
    setMessage("Be careful out there!!! It could get wild!!!");
    setAnimation("spin");
  } else if (
    props.currentWeather.current.condition.toLowerCase().indexOf(rainString) >=
    0
  ) {
    setImage(imageObject.rain);
    setMessage("Rain, rain, go away...👀");
    setAnimation("tilt");
  } else if (
    props.currentWeather.current.condition.toLowerCase().indexOf(snowString) >=
    0
  ) {
    setImage(imageObject.ski);
    setMessage("SNOW! That can only mean one thing...GET OUT THOSE GOGGLES!");
    setAnimation("happyBounce");
  } else if (
    props.currentWeather.current.condition.toLowerCase().indexOf(cloudString) >=
      0 ||
    props.currentWeather.current.condition === "Overcast" ||
    props.currentWeather.current.condition === "Mist" ||
    props.currentWeather.current.condition === "Fog"
  ) {
    setImage(imageObject.questionable);
    setMessage(
      "There's nothing falling from the sky yet? But there's cloud, so it COULD...👀"
    );
    setAnimation("confused");
  } else if (props.currentWeather.current.apparent_temperature >= 30) {
    setImage(imageObject.hot);
    setMessage("Too. Freaking. Hot.");
    setAnimation("spin");
  } else if (props.currentWeather.current.apparent_temperature >= 25) {
    setImage(imageObject.warm);
    setMessage("Hot, but manageable 🤷‍♀️");
    setAnimation("shudderSlow");
  } else if (
    props.currentWeather.current.apparent_temperature >= 15 &&
    props.currentWeather.current.condition.toLowerCase().indexOf(sunString) >= 0
  ) {
    setImage(imageObject.happySun);
    setMessage("Juuuuuuuuust right.");
    setAnimation("happyBounce");
  } else if (
    props.currentWeather.current.apparent_temperature <= 0 &&
    props.currentWeather.current.apparent_temperature > -15
  ) {
    setImage(imageObject.cold);
    setMessage("It's a little chilly, but it's not too bad!");
    setAnimation("shudderSlow");
  } else if (props.currentWeather.current.apparent_temperature <= -15) {
    setImage(imageObject.frigid);
    setMessage("STAY INSIDE - IT'S NOT WORTH IT OUT THERE!!!");
    setAnimation("shudderFast");
  } else if (props.currentWeather.current !== undefined) {
    setImage(imageObject.fine);
    setMessage("It's fine, I guess...not GREAT, but it could be worse...");
    setAnimation("tilt");
  } else {
    setImage("");
    setMessage("");
    setAnimation("");
  }
};
